
import Bunyan from 'bunyan';
const  log = Bunyan.createLogger({name: "ApiField"});

import { NONE, API_METHOD } from '../constants/types';

class ApiMethod { 

  TYPE = API_METHOD;

  constructor(parent) { 
    this._params = { 
      parent,
      apiKey: NONE,
      value: NONE,
    }
  }

  $() { 
    const { method, _paramObjectKey } = this;
    const { apiKey, _default, parent } = this._params;

    parent[apiKey] = method;
  }

  as(apiKey) { 
    this._params.apiKey = apiKey;
    return this;
  }

}


export default ApiMethod;
